<div class="card" *ngIf="chartData && chartOptions">
    <div class="card-header">
        <h3>{{ heading | translate }}</h3>
    </div>

    <div class="card-body">
        <ngx-chartjs
            type="bar"
            [data]="chartData"
            [options]="chartOptions"
            [height]="350">
        </ngx-chartjs>
    </div>
</div>
